import { Link, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { ReactComponent as ChevronRight } from 'assets/icons/navigation/small/chevron-right-sm.svg';
import { BreadcrumbsContainer } from './styled';

const formatLabel = (segment, replaceMap, idLabels, capitalizeLabels) => {
  if (replaceMap?.[segment]) return replaceMap[segment];
  if (idLabels?.[segment]) return idLabels[segment];
  if (capitalizeLabels) {
    return segment
      .replace(/([a-z])([A-Z])/g, '$1 $2') // separa camelCase
      .replace(/-/g, ' ') // separa com hífen
      .replace(/\b\w/g, c => c.toUpperCase()); // capitaliza
  }
  return segment;
};

export const Breadcrumbs = ({
  extraCrumbs = [],
  replaceMap = {},
  idLabels = {},
  ignoreSegments = [],
  capitalizeLabels = true,
}) => {
  const location = useLocation();
  const paths = location?.pathname?.split('/')?.filter(Boolean);

  const baseCrumbs =
    paths
      ?.filter(segment => !ignoreSegments.includes(segment)) // remove os ignorados
      .map((segment, index, filteredPaths) => {
        const path = '/' + paths.slice(0, index + 1).join('/');
        const isLast = index === filteredPaths.length - 1;
        return {
          label: formatLabel(segment, replaceMap, idLabels, capitalizeLabels),
          to: isLast ? null : path,
        };
      }) || [];

  const allCrumbs = [...baseCrumbs, ...extraCrumbs];
  const total = allCrumbs.length;

  return (
    <BreadcrumbsContainer>
      <Link to="/dashboard">Dashboard</Link>
      {allCrumbs.length > 0 && <ChevronRight />}

      {allCrumbs.map((crumb, idx) => {
        const isLast = idx === total - 1;
        return (
          <span key={idx} className={`crumb ${isLast ? 'last' : ''}`}>
            {crumb.to && !isLast ? <Link to={crumb.to}>{crumb.label}</Link> : <span>{crumb.label}</span>}
            {!isLast && <ChevronRight />}
          </span>
        );
      })}
    </BreadcrumbsContainer>
  );
};

Breadcrumbs.propTypes = {
  extraCrumbs: PropTypes.array,
  replaceMap: PropTypes.object,
  idLabels: PropTypes.object,
  ignoreSegments: PropTypes.array,
  capitalizeLabels: PropTypes.bool,
};
